/**
 * @generated SignedSource<<77f480b74ee835329b5f02e593899543>>
 * @relayHash 0e4d01e2b02d9f46cf22952f484f43d5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 94729b7c7d5acfef39bf36ed38e4eea66c90ed28cd95a1badcbdd06f5b58102a

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type YourAgentResultsQuery$variables = {
  cloudId: string;
  product?: string | null;
};
export type YourAgentResultsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"YourAgentResults_owned" | "YourAgentResults_starred">;
};
export type YourAgentResultsQuery = {
  response: YourAgentResultsQuery$data;
  variables: YourAgentResultsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "product"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "kind": "Variable",
  "name": "product",
  "variableName": "product"
},
v3 = [
  (v1/*: any*/),
  (v2/*: any*/)
],
v4 = {
  "kind": "Literal",
  "name": "first",
  "value": 24
},
v5 = [
  (v1/*: any*/),
  (v4/*: any*/),
  {
    "kind": "Literal",
    "name": "input",
    "value": {
      "onlyMyAgents": true
    }
  },
  (v2/*: any*/)
],
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = [
  {
    "concreteType": "AgentStudioAgentEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "AgentStudioAssistant",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "kind": "ScalarField",
            "name": "description"
          },
          {
            "kind": "ScalarField",
            "name": "isVerified"
          },
          {
            "kind": "ScalarField",
            "name": "isFavourite"
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__id"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "icon"
          },
          {
            "kind": "ScalarField",
            "name": "externalConfigReference"
          },
          {
            "kind": "ScalarField",
            "name": "identityAccountId"
          },
          {
            "kind": "LinkedField",
            "name": "identityAccount",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isUser"
              },
              {
                "kind": "ScalarField",
                "name": "picture"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "appType"
                  }
                ],
                "type": "AppUser"
              },
              (v6/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "creatorType"
          },
          {
            "kind": "ScalarField",
            "name": "forgeCreator"
          },
          {
            "concreteType": "TeamV2",
            "kind": "LinkedField",
            "name": "authoringTeam",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "displayName"
              },
              (v6/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "name": "creator",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v7/*: any*/),
              {
                "kind": "ScalarField",
                "name": "accountStatus"
              },
              (v6/*: any*/)
            ]
          },
          (v8/*: any*/)
        ]
      },
      {
        "kind": "ScalarField",
        "name": "cursor"
      }
    ]
  },
  {
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "endCursor"
      },
      {
        "kind": "ScalarField",
        "name": "hasNextPage"
      }
    ]
  }
],
v10 = [
  "cloudId",
  "product",
  "input"
],
v11 = [
  (v1/*: any*/),
  (v4/*: any*/),
  {
    "kind": "Literal",
    "name": "input",
    "value": {
      "onlyFavouriteAgents": true
    }
  },
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "YourAgentResultsQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "kind": "FragmentSpread",
        "name": "YourAgentResults_owned"
      },
      {
        "args": (v3/*: any*/),
        "kind": "FragmentSpread",
        "name": "YourAgentResults_starred"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "YourAgentResultsQuery",
    "selections": [
      {
        "alias": "ownedAgents",
        "args": (v5/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v9/*: any*/)
      },
      {
        "alias": "ownedAgents",
        "args": (v5/*: any*/),
        "filters": (v10/*: any*/),
        "handle": "connection",
        "key": "YourAgentResults_ownedAgents",
        "kind": "LinkedHandle",
        "name": "agentStudio_getAgents"
      },
      {
        "alias": "starredAgents",
        "args": (v11/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v9/*: any*/)
      },
      {
        "alias": "starredAgents",
        "args": (v11/*: any*/),
        "filters": (v10/*: any*/),
        "handle": "connection",
        "key": "YourAgentResults_starredAgents",
        "kind": "LinkedHandle",
        "name": "agentStudio_getAgents"
      }
    ]
  },
  "params": {
    "id": "94729b7c7d5acfef39bf36ed38e4eea66c90ed28cd95a1badcbdd06f5b58102a",
    "metadata": {},
    "name": "YourAgentResultsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d080ebc78a6e9e9416d7c6efd2a04a2b";

export default node;
